import ModelData from "../../../public/model_data";
import AppData from "../../../public/const/app_data";
import ModuleManager from "../../../../framework/core/module_manager";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import AppController from "../../../../sdk/app_controller";

const { ccclass, property } = cc._decorator;

export interface ICustomConvertionReq{
    businessBankId?: number      //银商id 银商会话时使用
    problemTypeCode: string     //问题类型编码
    customType: number          //会话类型(1-系统会话 2-银商会话 3-游客会话)
    orderOutId?: string          //订单outId 银商会话时使用
}

@ccclass
export default class CustomerServiceUtil{
    
    //获取咨询类型 
    static getProblemType(success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/problem/getProblemType?',
            params: {
                language: AppData.apiLanguage || 'zh-CN'
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    }

    //获取常见问题 problemTypeCode 问题类型编码
    static getCustomProblem(problemTypeCode: string, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/problem/getCustomProblem?',
            params: {
                problemTypeCode: problemTypeCode
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    }

    //关闭会话 cid 会话id
    static closeConvertion(cid: number, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/closeConvertion?',
            params: {
                cid: cid,
                gameUserId: ModelData.instance.roleData.id,
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    }  
    
    //获取客服信息 customId 客服id
    static getCustomById(customId: number, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/getCustomById?',
            params: {
                customId: customId,
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    }

    //获取新的客服会话 customId 客服id
    static getNewCustomConvertion(reqData: ICustomConvertionReq, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let deviceInfo = AppController.instance.deviceInfo()
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/getCustomConvertion?',
            params: {
                gameUserId: ModelData.instance.roleData.id,
                gameId: AppData.gameName, 
                deviceType: deviceInfo.model,
                osTypeVersion: deviceInfo.os,
            }
        }
        for (const key in reqData) {
            if (reqData.hasOwnProperty(key)) {
                const element = reqData[key];
                requestData.params[key] = element;
            }
        }
        CustomerServiceUtil.ensureToken(function(){
            requestData.params["token"] = ModelData.instance.userToken
            CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
        }, fail, mvvmBase)   
    }  
    
    //获取未读消息数量
    //customType 会话类型(1-系统会话 2-银商会话 3-游客会话)
    static getNewChatCount(customType: number, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/getNewChatCount?',
            params: {
                gameUserId: ModelData.instance.roleData.id,
                customType: customType,                
            }
        }        
        CustomerServiceUtil.ensureToken(function(){
            requestData.params["token"] = ModelData.instance.userToken
            CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
        }, fail, mvvmBase)        
    }   
    
    //是否已创建会话
    //customType 会话类型(1-系统会话 2-银商会话 3-游客会话)
    static isCreateConversation(customType: number, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/isCreateConversation?',
            params: {
                gameUserId: ModelData.instance.roleData.id,
                customType: customType,
                language: AppData.apiLanguage || 'zh-CN',
            }
        }
        CustomerServiceUtil.ensureToken(function(){
            requestData.params["token"] = ModelData.instance.userToken
            CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
        }, fail, mvvmBase)
    }   
    
    //获取聊天记录
    //customType 会话类型(1-系统会话 2-银商会话 3-游客会话)
    //pageNum 分页页数
    //pageSize 分页长度
    static queryChatHistoryPage(customType: number, pageNum: number, pageSize: number, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/queryChatHistoryPage?',
            params: {
                gameUserId: ModelData.instance.roleData.id,
                customType: customType,
                pageNum: pageNum || 1,
                pageSize: pageSize || 50,                
            }
        }
        CustomerServiceUtil.ensureToken(function(){
            requestData.params["token"] = ModelData.instance.userToken
            CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
        }, fail, mvvmBase)   
    }  

    //获取聊天记录
    //chatIds 消息Id列表
    static readByChatId(chatIds: number[], success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/readByChatId?',
            params: {
                gameUserId: ModelData.instance.roleData.id,
                chatIds: chatIds,
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    } 

    //发送消息
    //chatType 消息类型(1-文本 2-图片 3-语音)
    //cid   会话id
    //data  内容(文本或者图片url,多个图片’,’分割)
    static sendChat(chatType: number, cid: string, data: string, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/message/custom/sendChat?',
            params: {
                gameUserId: ModelData.instance.roleData.id,                
                chatType: chatType,
                cid: cid,
                data: data,
            }
        }
        CustomerServiceUtil.ensureToken(function(){
            requestData.params["token"] = ModelData.instance.userToken
            CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
        }, fail, mvvmBase)   
    } 

    private static ensureToken(success, fail, mvvmBase: MVVMBase){
        if(ModelData.instance.userToken == ''){
            CustomerServiceUtil.createTempToken(function(data){
                ModelData.instance.userToken = data.tempToken                
                success && success()
            }, function(err){
                fail && fail(err)
            }, mvvmBase)
        }else{
            success && success()
        }
    }

    //获取临时token
    static createTempToken(success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        let requestData = {
            baseUrl: AppData.httpApiMessageUrl + '/commons/token/createTempToken?',
            params: {
                deviceId: AppController.instance.deviceInfo().deviceId
            }
        }
        CustomerServiceUtil._get_http(requestData, success, fail, mvvmBase, showNetPrompt)
    } 

    private static _get_http(requestData, success, fail, mvvmBase: MVVMBase, showNetPrompt?: boolean){
        requestData.showNetPrompt = showNetPrompt
        mvvmBase.apiHttpGet(requestData, (retData) => {
            success(retData.data)
        }, (retData) => {
            ModuleManager.instance.toast500error(retData)
            fail(retData)
        })
    }

}